import React from 'react';
import Layout from '../../components/Layout/Layout';
import team_1 from '../../assets/team_1.jpeg';
import team_2 from '../../assets/lucie_benjamin.jpeg';
import agenceFacade from '../../assets/agence_facade.jpeg';
import agenceEntree from '../../assets/agence_entree.jpeg';
import agenceSalle from '../../assets/agence_salle.jpeg';
import './Agency.css';

// Sections « Notre histoire » et « Notre équipe » masquées temporairement à la demande de l'agence
const SHOW_HISTOIRE_EQUIPE = false;

const Agency: React.FC = () => {
    // Notre Histoire data
    const histoireText = (
        <>
            <p>
                Toute grande aventure commence par une passion. La nôtre, c’est l’immobilier. Un métier
                découvert il y a plus de 10 ans.
            </p>
            <p>
                Puis il y a eu une rencontre, au sein de la même agence. Les journées, les mois et les
                années s’enchaînent. La passion est là, l’amitié aussi. Mais quelque chose manque.
            </p>
            <p>
                Une question revient sans cesse: et si on faisait les choses autrement ? Et si on créait une
                agence à notre image ?
            </p>
            <p>
                C’est ainsi qu’est née une idée.
            </p>
            <p>
                Puis une évidence.
            </p>
        </>
    );

    // Nos Valeurs data
    const valeurs = [
        {
            title: 'PROXIMITÉ',
            description: 'Parce que la relation client est notre priorité, nous avons fait le choix d’une agence à taille humaine, avec un interlocuteur unique pour construire une relation de confiance durable.',
        },
        {
            title: 'TRANSPARENCE',
            description: 'Parce qu’une gestion durable passe impérativement par la confiance, nous nous engageons à mettre à votre disposition l’ensemble des documents relatifs à votre bien immobilier.',
        },
        {
            title: 'EXPÉRIENCE',
            description: 'Parce que l’immobilier ne s’improvise pas, nous mettons au service de nos clients notre expertise locale reconnue.',
        },
        {
            title: 'VALORISATION',
            description: 'Vous conseiller, entretenir et valoriser votre patrimoine dans le temps.',
        }
    ];

    return (
        <Layout>
            <section className="agence">
                {/* Photos de l'agence */}
                <div className="agence-section">
                    <div className="agence-photos">
                        <img src={agenceFacade} alt="Façade de l'agence AKTE Immobilier" className="agence-photo agence-photo-main"/>
                        <img src={agenceEntree} alt="Entrée de l'agence AKTE Immobilier" className="agence-photo"/>
                        <img src={agenceSalle} alt="Salle de réunion de l'agence" className="agence-photo"/>
                    </div>
                </div>

                {SHOW_HISTOIRE_EQUIPE && (<>
                {/* Notre Histoire Section */}
                <div className="agence-section">
                    <h2 className="section-title">Notre histoire</h2>
                    <div className="histoire-content">
                        <img src={team_1} alt="Fondateurs" className="histoire-image"/>
                        <div className="histoire-text">
                            {histoireText}
                        </div>
                    </div>
                </div>
                {/* Notre Équipe Section */}
                <div className="agence-section">
                    <h2 className="section-title">Notre équipe</h2>
                    <div className="team-container">
                        {/* Benjamin BUCHET */}
                        <div className="team-member-card">
                            <div className="team-member-info">
                                <p className="team-member-name">Benjamin BUCHET</p>
                                <p className="team-member-description">
                                    Impliqué dans la gestion de copropriété depuis plus de 15 ans,
                                    j'ai accompagné des immeubles de toutes tailles, de 3 à 150 logements.
                                    J'apprécie tout particulièrement participer au redressement des copropriétés
                                    fragiles et piloter les projets de rénovation énergétique qui demandent une écoute
                                    et une approche pragmatique pour construire des solutions durables.
                                </p>
                            </div>
                            <div className="team-member-photo-container">
                                <img src={team_2} alt="Notre équipe" className="team-photo"/>
                            </div>
                            <div className="team-member-info">
                                <p className="team-member-name">Lucie PETITCOLAS</p>
                                <p className="team-member-description">
                                    Forte de plus de 15 ans d'expérience dans le domaine de la
                                    copropriété, j'accompagne mes clients avec une expertise spécifique
                                    sur les copropriétés complexes, notamment de type ERP ou IGH.
                                    J'apprécie tout particulièrement le pilotage de projets et l'animation
                                    de réunions, avec une approche humaine et structurée.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                </>)}

                {/* Nos Valeurs Section */}
                <div className="agence-section">
                    <h2 className="section-title">Nos valeurs</h2>
                    <div className="valeurs-grid">
                        {valeurs.map((valeur, index) => (
                            <div key={index} className="valeur-card">
                                <h3 className="valeur-title">{valeur.title}</h3>
                                <p className="valeur-description">{valeur.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </Layout>
    );
};

export default Agency;
